import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

import { useFieldArray, useFormContext } from 'react-hook-form'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

import styles from './HFInputs.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import Checkbox from '@jimmyboys/liita-ui/dist/components/Checkbox'
import toBool from 'utils/toBool'
import { numericLateralityOptions } from 'controllers/TaskManager/formOptions'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import OptionGroup from '@jimmyboys/liita-ui/dist/components/OptionGroup'

const HFBodyPartInjury = (props) => {
	const { name, data } = props

	const { i18n } = useGlobal()

	const { bodyParts, injuries } = data

	const { fields, update, append, remove } = useFieldArray({
		name,
		keyName: 'key',
	})

	const {
		formState: { errors },
	} = useFormContext()
	const bodyPartsError = errors?.process?.bodyParts?.message

	const setPrimaryBodyPart = (bodyPartPos) => {
		let idx = 0

		fields.forEach(({ key, ...field }) => {
			if (idx === bodyPartPos) {
				const result = {
					...field,
					primary: !toBool(field.primary),
				}

				update(idx, result)
			} else {
				if (field.primary) {
					const result = {
						...field,
						primary: false,
					}
					update(idx, result)
				}
			}

			idx++
		})
	}

	return (
		<>
			{bodyPartsError && (
				<HStack className={styles['primary-error']}>
					<Icon name='warning' height='14px' width='14px' />
					<small>{bodyPartsError}</small>
				</HStack>
			)}
			<HStack
				className={styles['body-part-injury-header']}
				columns={[1, 1]}
			>
				<h5>{i18n`Body part`}</h5>
				<h5>{i18n`Injury`}</h5>
			</HStack>
			{fields.map(({ key, ...field }, index) => {
				return (
					<HStack
						key={key}
						align='center'
						wrap='nowrap'
						gap='xsmall'
						className={styles['body-part-injury-field']}
					>
						<VStack>
							<HStack
								className={
									styles['body-part-injury-selectors-section']
								}
								columns={[0.1, 1, 1]}
								gap='small'
							>
								<Checkbox
									className={styles['light-checkbox']}
									value={`${field.primary}`}
									checked={field.primary}
									onChange={() => {
										setPrimaryBodyPart(index)
									}}
								/>
								<div>
									<Dropdown
										options={bodyParts || []}
										value={field.bodyPartId}
										optionsAlign='right'
										searchable={true}
										noData={i18n`No results`}
										onChange={(event) => {
											const result = {
												...field,
												bodyPartId: event.target.value,
											}
											update(index, result)
										}}
									/>
								</div>
								<div>
									<Dropdown
										options={injuries || []}
										value={field.injuryId}
										searchable={true}
										optionsAlign='right'
										noData={i18n`No results`}
										onChange={(event) => {
											const result = {
												...field,
												injuryId: event.target.value,
											}
											update(index, result)
										}}
									/>
								</div>
							</HStack>
							<HStack
								className={
									styles['body-part-laterality-selector']
								}
							>
								<h5>{i18n`Laterality`}</h5>
								<OptionGroup
									value={field.lateralityId}
									options={numericLateralityOptions}
									onChange={(event) => {
										const result = {
											...field,
											lateralityId: event.target.value,
										}
										update(index, result)
									}}
								/>
							</HStack>
						</VStack>
						<Icon
							className={styles['remove-button']}
							onClick={(e) => {
								e.preventDefault()
								remove(index)
							}}
							name='minus'
							height='12px'
							width='12px'
						/>
					</HStack>
				)
			})}
			<ActionButton
				className={styles['add-body-part-injury-button']}
				secondary
				onClick={(e) => {
					e.preventDefault()
					append({
						bodyPartId: '',
						injuryId: '',
						primary: false,
						lateralityId: '',
					})
				}}
			>
				<Icon name='plus' height='14px' width='14px' />
				<small>{i18n`Add`}</small>
			</ActionButton>
		</>
	)
}

export default HFBodyPartInjury
